var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBounced = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.721,
    height: 10.99,
    viewBox: "0 0 16.721 10.99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.414 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.028,12.024l5.405,5.2,8.433-8.433",
    transform: "translate(-3.028 -8.231)",
    fill: "none",
    stroke: "#d92100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.538,8.231h3.8V12",
    transform: "translate(-3.028 -8.231)",
    fill: "none",
    stroke: "#d92100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBounced, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bounced.2de5285c.svg";
export { ForwardRef as ReactComponent };